// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const collectionActions = require('../collection/actions')
const collectionEditModalActions = require('../collection-edit-modal/actions')
// Sibling imports
const CollectionProfileNav = require('./component-dumb')

function mapStateToProps(state) {
  return {
    collection: state.collection,
    isSelfProfile: state.collection['user_id'] === state.user.id
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
  return {
    onEditClick: dispatchAction(collectionEditModalActions.show),
    onFollowClick: dispatchAuthRequiredAction(
      collectionActions.toggleFollowing,
      authModalActions.showSignup
    ),
    onShareClick: dispatchAction(collectionActions.showCollectionShareModal)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    CollectionProfileNav
  )
)
